import { render, staticRenderFns } from "./r-item-shop-page.vue?vue&type=template&id=142499be"
import script from "./r-item-shop-page.vue?vue&type=script&lang=js"
export * from "./r-item-shop-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142499be')) {
      api.createRecord('142499be', component.options)
    } else {
      api.reload('142499be', component.options)
    }
    module.hot.accept("./r-item-shop-page.vue?vue&type=template&id=142499be", function () {
      api.rerender('142499be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-shop/r-item-shop-page.vue"
export default component.exports